import React, { useEffect } from 'react';
import Helmet from 'react-helmet';

//LPL Global Google Tag Manager Pixel - please do not remove
const LPLGlobalTagManagerPixel = () => {
  useEffect(() => {
    // Add separate dataLayer for LPL
    window.dataLayerLPL = window?.dataLayerLPL || [];
    //Define gtag globally
    window.gtag = function() {
      window.dataLayerLPL.push(arguments);
    };
    window.gtag('js', new Date());
    window.gtag('config', 'DC-14818909');
  }, []);

  return (
    <Helmet>
      <script
        async
        src="https://www.googletagmanager.com/gtag/js?id=DC-14818909&l=dataLayerLPL"></script>
    </Helmet>
  );
};

export default LPLGlobalTagManagerPixel;
